import { ISelectItem } from '@lla-platform/core/core-ui'

export enum DailyAverageDateFilter {
  WorkOrderDate = 'WorkOrderDate',
  InvoiceDate = 'InvoiceDate',
  OneDayWork = 'OneDayWork'
}

export const DailyAverageDateFilterToLabel: { [key: string]: string } = {
  WorkOrderDate: 'Work Order Date',
  InvoiceDate: 'Invoice Date',
  OneDayWork: 'One Day Work'
}

export const DailyAverageDateFilterItems: ISelectItem[] = [
  {
    label: DailyAverageDateFilterToLabel[DailyAverageDateFilter.InvoiceDate],
    value: DailyAverageDateFilter.InvoiceDate
  },
  {
    label: DailyAverageDateFilterToLabel[DailyAverageDateFilter.WorkOrderDate],
    value: DailyAverageDateFilter.WorkOrderDate
  },
  {
    label: DailyAverageDateFilterToLabel[DailyAverageDateFilter.OneDayWork],
    value: DailyAverageDateFilter.OneDayWork
  }
]
